// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__EDapd","container":"styles_container__e7qWj"};